import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllPartenaires } from "../../services/partenairesServices";

const TousLesPartenaires = () => {
  const [partenaires, setPartenaires] = useState([]);

  useEffect(() => {
    const fetchPartenaires = async () => {
      try {
        const all = await getAllPartenaires();
        const actifs = all.filter((p) => p.is_active);
        setPartenaires(actifs);
      } catch (err) {
        console.error("Erreur chargement partenaires :", err);
      }
    };
    fetchPartenaires();
  }, []);

  return (
    <div className="max-w-[1280px] mx-auto px-4 py-10 mt-[100px]">
      <h1 className="text-3xl font-bold text-center mb-8 uppercase text-primary">
        Tous Nos Partenaires
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {partenaires.map((p) => (
          <div
            key={p.id}
            className="bg-white dark:bg-slate-700 rounded-lg shadow-md p-4 flex flex-col items-center hover:scale-[1.02] transition"
          >
            <img
              src={p.photo_url}
              alt={p.nom}
              className="w-28 h-28 object-contain mb-4"
            />
            <h2 className="text-lg font-semibold text-center dark:text-white mb-4">
              {p.nom}
            </h2>

            <div className="mt-auto flex gap-2 pt-4">
              <a
                href={p.link_url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 text-sm hover:text-white"
              >
                Lien Internet
              </a>
              {p.is_detail && (
                <Link
                  to={`/partenaires/${encodeURIComponent(p.nom)}`}
                  className="bg-primary text-white px-3 py-1 rounded hover:bg-primary text-sm hover:text-white"
                >
                  Détails
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TousLesPartenaires;
